<template>
  <v-row dense justify="center">
    <v-col cols="12" class="content">
      <v-card>
        <v-form ref="form">
          <v-col cols="12">
            <v-row align="center" justify="center">
              <v-col :cols="12" sm="4">
                <BaseDatePicker ref="date"
                                :rules="[() => !!date || 'Поле обязательно']"
                                :value="date"
                                @dateUpdated="setDate"
                                picker-type="month"
                                label="Дата" />
              </v-col>
              <v-col :cols="12" sm="2">
                <v-text-field ref="hours"
                              v-model="hours"
                              :rules="[() => !!hours || 'Поле обязательно']"
                              label="Количество часов" />
              </v-col>
              <v-col :cols="12" sm="6">
                <v-select ref="users"
                          :multiple="true"
                          :items="usersListFiltered"
                          :value="employees"
                          :rules="[() => !!employees.length > 0 || 'Поле обязательно']"
                          :max-elements="1"
                          :menu-props="{maxHeight:204, offsetY:true}"
                          @input="setEmlpoyees"
                          label="Сотрудники"
                          item-value="id"
                          item-text="name" />
              </v-col>
              <!--              <v-col v-for="product in globalProds"-->
              <!--                     :key="product.value"-->
              <!--                     cols="12"-->
              <!--                     lg="3">-->
              <!--                <v-text-field v-model="product.amount" :label="product.name" />-->
              <!--              </v-col>-->
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row align="center" justify="center">
              <v-btn
                @click="submitReport"
                color="primary"
                class="mb-2">
                Начать
              </v-btn>
            </v-row>
          </v-col>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>

import {mapState} from 'vuex'
import BaseDatePicker from '../../base/BaseDatePicker'
import ReportsMixin from '../new/ReportsMixin'

export default {
  name: "ReportPsychologistsNew",
  components: {BaseDatePicker},
  mixins: [ReportsMixin],
  props: {
    reportId: {
      type: [String, Number],
      default: null
    },
    reportInfo: {
      type: [Object],
      default: null
    }
  },
  data () {
    return {
      tooltipShow: false,
      errorMessages: '',
      lengthHours: [2, 3, 4, 5],
      customers_num: 0,
      loading: true,
      dialogLoading: !!this.reportId,
      consultations_num: '',
      advices: '',
      notFinished: true,
      isPageDisabled: false,
      dateRules: [
        v => !!v || 'Поле обязательно',
        v => this.isValidDate(v) || 'Неверная дата'
      ],
      numericRules: [
        v => !!v || 'Поле обязательно',
        v => !isNaN(v) || 'Допустимы только численные значения'
      ]

    }
  },
  computed: {
    // globalProds () {
    //   let vm = this
    //   let filtered =[]
    //   if (vm.globalIndicatorsList && vm.globalIndicatorsList.length>0) {
    //     filtered = vm.globalIndicatorsList.filter(v =>  v.report_type.indexOf(vm.reportTypes[vm.$route.meta.reportType])>-1)
    //   // filtered.map(v => {...v,...{'value':v['name']==='Количество кейсов' ? vm.customers.length : v['value']}})
    //     filtered.map(v => { v['amount'] = v['name']==='Количество кейсов' ? vm.customers.length : v['amount']
    //                         v['readOnly'] = v['name']==='Количество кейсов'
    //                  return v
    //     }
    //                 )
    //   // this.$store.commit("newOutreachReports/setglobalIndicators", filtered)
    //
    //   }
    //
    //
    //   return filtered
    // },
    reportType () {
      return this.$route.meta.reportType
    },
    ...mapState({
      places: state => state.tableData.places,
      users: state => state.tableData.users,
      date: state => state.newOutreachReports.date,
      // place: state => state.newOutreachReports.place,
      employees: state => state.newOutreachReports.users,
      consultingsList: state => state.tableData.products

    }),
    hours: {
      get () {
        return this.$store.state.newOutreachReports.hours
      },
      set (hours) {
        this.$store.commit("newOutreachReports/setHours", hours)
      }
    },
    volunteers: {
      get () {
        return this.$store.state.newOutreachReports.volunteers
      },
      set (volunteers) {
        this.$store.commit("newOutreachReports/setVolunteers", volunteers)
      }
    },
    place: {
      get () {
        return this.$store.state.newOutreachReports.place
      },
      set (location) {
        this.$store.commit("newOutreachReports/setLocation", location)
      }
    },
    usersListFiltered () {
      const newList = this.users.filter(user => {
        return user.user_roles &&( (user.user_roles.some(role => role.value === 'Психолог')) || user.type==='админ')
      })
      return newList
    }
  },
  mounted: function () {
    if (this.reportId === 'new') {
      this.setEmlpoyees([this.$store.state.authentication.user.user_info.id])
    }
  },
  methods: {
    submitReport () {
      if (this.validate()) {
        // let router = this.reportType === 'outreach' ? 'ReportOutreachList' : 'ReportCaseList'
        this.$router.push({name: 'ReportPsychList'})
      }
    },
    setDate (e) {
      this.$store.commit("newOutreachReports/setDate", e)
    },
    setLocation (e) {
      this.$store.commit("newOutreachReports/setLocation", e)
    },
    setEmlpoyees (e) {
      this.$store.commit("newOutreachReports/setEmlpoyees", e)
    },
    validate () {
      return this.$refs.form.validate()
    }
  }
}
</script>

<style lang="scss" scoped>
.loading-dialog {
  background-color: #303030
}

.outreach-header {
  background-color: #1976d2 !important;
  opacity: 0.8;
  padding: 10px
}

.case-header {
  background-color: #ffc107 !important;
  opacity: 0.8;
  padding: 10px
}

.read-only-header {
  background-color: gray !important;
  opacity: 0.8;
  padding: 10px
}

.content {
  max-width: 800px;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/new/ReportPsychologistsNew.vue